import Select from '../plugins/Select';

$(document).ready(function () {
    $('form').each(function () {
        Select.get(`#${this.id}`);
    });
});